var map = {
	"./academic.svg": 11757,
	"./academic_1_1.svg": 37869,
	"./academic_1_2.svg": 27150,
	"./academic_1_3.svg": 65087,
	"./academic_2_1.svg": 14634,
	"./academic_2_2.svg": 75385,
	"./academic_2_3.svg": 51112,
	"./healthcare.svg": 68737,
	"./healthcare_1_1.svg": 50273,
	"./healthcare_1_2.svg": 45234,
	"./healthcare_1_3.svg": 83171,
	"./healthcare_2_1.svg": 23374,
	"./healthcare_2_2.svg": 55373,
	"./healthcare_2_3.svg": 56428,
	"./other.svg": 72586,
	"./sciences.svg": 95549,
	"./sciences_1_1.svg": 90109,
	"./sciences_1_2.svg": 27486,
	"./sciences_1_3.svg": 63887,
	"./sciences_2_1.svg": 46330,
	"./sciences_2_2.svg": 88265,
	"./sciences_2_3.svg": 12760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44282;